<app-base-template (modal)="openModal(content)" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)" (index)="createIndex()" [showIndex]="showIndex"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"[dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Upload Faq Document</div>
</div>
<div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
  <div class="row mar-lft-rgt-0">
<div class="text-center">
  <app-material-fileupload [target]="fileUploadUrl" [text]="uploadButtonName"
                           (complete)="onFileComplete($event)" [formData]="formData"
                           (uploadError)="onFileError($event)"></app-material-fileupload>
</div>
</div>
  <div class="row mar-lft-rgt-0">
<div class="col-sm-6 pad-15 text-center" [innerHTML]="uploadSuccessMessage"></div>
</div>
</div>
<div class="modal-footer pad-8">
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
</div>
</ng-template>
<notifier-container></notifier-container>